import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { EclipseOfferingApiClientContext } from './eclipse-offering.context';
import { EclipseOfferingQueriesConfig } from './eclipse-offering.queries';
export const EclipseOfferingApiClient = {
  ...createApiClient(EclipseOfferingQueriesConfig),
  context: EclipseOfferingApiClientContext
};
//# sourceMappingURL=eclipse-offering.api-client.js.map